import PlanTerms from './PlanTerms';

import { RouteObject } from 'react-router-dom';

export const PlanTermsRoutes: (prefix: string) => RouteObject[] = (prefix) => [
  {
    path: `${prefix}/plan-terms/:planNumber`,
    element: <PlanTerms />,
  },
];
